/* eslint-disable */
import validator from 'validator';
import React from 'react';
import moment from 'moment';

export const optional = () => true;
export const required = (value) => {
  const newValue = value ? value.toString() : '';
  return !validator.isEmpty(newValue);
};
export const maxLength = (length) => {
  function mLength(value) {
    const newValue = value ? value.toString() : '';
    return newValue.toString().trim().length <= length;
  }

  return mLength;
};
export const validEmail = (value) => {
  const newValue = value ? value.toString() : '';
  if(!isValidEmail(newValue)){
    return false;
  }
  return true;
};
export const isValidEmail = (email) => {
  return /\S+@\S+\.\S+/.test(email);
}
export const length = (len) => {
  function mLength(value) {
    const newValue = value ? value.toString() : '';
    return newValue.toString().trim().length === len;
  }

  return mLength;
};

export const email = (value) => {
  if (!validator.isEmail(value)) {
    return `${value} is not a valid email.`;
  }
};

export const lt = (value, props) => {
  // get the maxLength from component's props
  if (!value.toString().trim().length > props.maxLength) {
    // Return jsx
    return (
      <span className="error">
        The value exceeded {props.maxLength} symbols.
      </span>
    );
  }
  return null;
};

export const checkEventDate = (eventTime) => {
  return function checkDate(eventDate) {
    let chosenDate = moment(eventDate);
    let todayDate = moment(Date.now());
    if (!eventTime) {
      return !chosenDate.isAfter(todayDate);
    } else {
      if (!chosenDate.isAfter(todayDate)) {
        return true;
      }
      const chosenDateTimeString = moment(eventDate).format('YYYY-MM-DD') + ' ' + moment(eventTime).format('HH:mm A'); 
      let chosenDateTime = moment(chosenDateTimeString);
      let todayDateTime = moment();
      return !chosenDateTime.isAfter(todayDateTime);
    }
  };
};

export const checkDateOnly = (date) => {
  let chosenDate = moment(date);
  if (!chosenDate) {
    return false;
  } 
  return !validator.isAfter(chosenDate.format('YYYY-MM-DD'));
};

export const checkEventTime = (eventDate) => {
  return function checkTime(eventTime) {
    if (!eventDate) {
      return true;
    } else {
      const chosenDateTimeString = moment(eventDate).format('YYYY-MM-DD') + ' ' + moment(eventTime).format('HH:mm A'); 
      let chosenDateTime = moment(chosenDateTimeString);
      let todayDateTime = moment();
      return !chosenDateTime.isAfter(todayDateTime);
    }
  };
};

export const password = (value, props, components) => {
  // NOTE: Tricky place. The 'value' argument is always current component's value.
  // So in case we're 'changing' let's say 'password' component - we'll compare it's value with 'confirm' value.
  // But if we're changing 'confirm' component - the condition will always be true
  // If we need to always compare own values - replace 'value' with components.password[0].value and make some magic with error rendering.
  if (value !== components.confirm[0].value) {
    // components['password'][0].value !== components['confirm'][0].value
    // 'confirm' - name of input
    // components['confirm'] - array of same-name components because of checkboxes and radios
    return <span className="error">Passwords are not equal.</span>;
  }
  return null;
};



// WEBPACK FOOTER //
// ./app/utils/validation/validator.js